import React, { useState } from 'react'
import Filter from '../components/Filter'
import Students from './Students'
import { useDispatch } from 'react-redux'
import { deleteStudentById, getStudentsList } from '../features/studentSlice'
import DeleteModule from '../components/DeleteModule'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Dashboard = () => {
  const dispatch = useDispatch()
  const [students, setStudents] = useState([])
  const [formstate, setFormState] = useState({
    class: "",
    section: "",
  });

  const [selectedDeleteID, setSelectedDeleteID] = useState(null);
  const handleDelete = () => {
    if (!selectedDeleteID) return
    dispatch(deleteStudentById(selectedDeleteID))
    const notify = () => {
      toast.warn("Student Deleted Successfully!");
    };
    notify();
    setSelectedDeleteID(null)
  }

  const handleState = (name, value) => {
    setFormState({
      ...formstate,
      [name]: value,
    });
  }

  const handleSubmit = () => {
    dispatch(getStudentsList())
  };

  return (
    <div className='w-full h-full relative'>
      {selectedDeleteID && <div className='absolute top-0 left-0 bg-transparent w-full h-full z-100'>
        <DeleteModule handleDelete={handleDelete} setSelectedDeleteID={setSelectedDeleteID} />
      </div>}

      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <section className='max-w-6xl my-16 mx-auto'>
        <Filter formstate={formstate} handleSubmit={handleSubmit} handleState={handleState} />
        <Students setSelectedDeleteID={setSelectedDeleteID} students={students} />
      </section>
    </div>
  )
}
export default Dashboard;
